import { render } from "./SectionIndexView.vue?vue&type=template&id=37c81380"
import script from "./SectionIndexView.vue?vue&type=script&lang=js"
export * from "./SectionIndexView.vue?vue&type=script&lang=js"

import exportComponent from "/srv/git/index-webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__